import { render, staticRenderFns } from "./locked.vue?vue&type=template&id=59f107a4&scoped=true&"
import script from "./locked.vue?vue&type=script&lang=js&"
export * from "./locked.vue?vue&type=script&lang=js&"
import style0 from "./locked.vue?vue&type=style&index=0&id=59f107a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f107a4",
  null
  
)

export default component.exports